import { CREATE_SUBCATEGORY_PRODUCTS, DELETE_SUBCATEGORY_PRODUCTS, EDIT_SUBCATEGORY_PRODUCTS, LIST_SUBCATEGORY_PRODUCTS } from "../admin/actions/types"

const initialState = {
    isLoadingSubCategoriesList: false,
    subCategoriesList: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case "IS_LOADING_SUB_CATEGORIES":
            return { ...state, isLoadingSubCategoriesList: true }
        case LIST_SUBCATEGORY_PRODUCTS:
            return { ...state, subCategoriesList: action.payload, isLoadingSubCategoriesList: false }
        case CREATE_SUBCATEGORY_PRODUCTS:
            return { ...state, subCategoriesList: [...state.subCategoriesList, action.payload] }
        case EDIT_SUBCATEGORY_PRODUCTS:
            const subCategoriesList = state.subCategoriesList.map(subcategory => {
                if (subcategory._id === action.payload._id) {
                    subcategory.name = action.payload.name
                }
                return subcategory;
            })

            return { ...state, subCategoriesList }
        case DELETE_SUBCATEGORY_PRODUCTS:
            const subCategoryDelete = state.subCategoriesList.filter(subCategory => {
                
                return subCategory._id !== action.payload;
            })
            return { ...state, subCategoriesList:subCategoryDelete}
        default: return state
    }

}